export default __webpack_public_path__ + "static/media/helo2.73cf5889.png";